<div class="videoContainer">
	<div class="bssContainer">
		<div class="leftSide">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="0" />
		</div>
		<div class="rightTop">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="1" />
		</div>
		<div class="rightBottom">
			<sim-screen-container [cameraLayoutOptionsContainer]="cameraLayoutOptionsContainer" [screenIndex]="2" />
		</div>
	</div>
</div>
